import * as React from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";
import {
  VendorCheckpointAssignDocument,
  vendorCheckpointDocumentlist,
  vendorFileUpload,
  vendorUploadSubmitCheckpointLocation,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import "./upload-modal.scss";
import qs from "query-string";
import { FileUploader } from "react-drag-drop-files";
import DragAndDropFileComponent from "@_common/file-drag-drop";
interface IUploadModalProps {
  isOpen: boolean;
  handleModal: () => void;
  getData: () => void;
  vendorInfo: object;
  mainParams: any;
  getDashboardInfo: () => void;
}

const UploadModal: React.FunctionComponent<IUploadModalProps> = (props) => {
  const { mainParams } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);

  const handleSubmit = async () => {
    let uploadIds =
      getValue(uploadedDocuments, `length`, 0) > 0
        ? uploadedDocuments.map((item: any) => item.id)
        : [];
    let ids =
      getValue(selectedIds, `length`, 0) > 0 &&
      selectedIds.map((item: any) => {
        return item.split(":")[1];
      });
    let allIds =
      getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [].concat(ids);

    try {
      setSubmitLoading(true);
      let payload = {
        vendor_checkpoint: [
          {
            id: getValue(props, `vendorInfo.id`, ""),
            document_ids: allIds,
          },
        ],
      };
      let resp = await vendorUploadSubmitCheckpointLocation(payload);
      if (resp) {
        setSubmitLoading(false);
        props.handleModal();
        props.getData();
        props.getDashboardInfo();
        toast.success("Uploaded successfully");
      } else {
        props.getData();
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  React.useEffect(() => {
    getDocumentsData();
  }, []);

  const [page_no, setPageNo] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const getDocumentsData = async () => {
    // if( mainParams.id){}
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: page_no ? page_no : 10,
      page_size: limit ? limit : 10,
      location_id: mainParams.id
        ? mainParams.id
        : getValue(props, `vendorInfo.location.id`, ""),
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    // setIsLoading(true);
    try {
      let resp = await vendorCheckpointDocumentlist(queryRequest);
      if (resp) {
        // setIsLoading(false);
        setAssignDocumentList(
          getValue(resp, `data.documents`, []).filter((item: any) =>
            getValue(item, `is_assigned`, false)
          )
        );
        setUnAssignDocumentList(
          getValue(resp, `data.documents`, []).filter(
            (item: any) => !getValue(item, `is_assigned`, false)
          )
        );
      } else {
        // setIsLoading(false);
      }
    } catch (error) {
      // setIsLoading(false);
    }
  };

  const [uploadLoading, setUploadLoading] = React.useState(false);
  const handleUploadDocumnets = async (e: any) => {
    const files = Array.from(e);

    setUploadLoading(true);

    try {
      for (const item of files) {
        try {
          const formData = new FormData();
          formData.append("file", item as any);

          const resp = await vendorFileUpload(formData);

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e = null;
      setUploadedDocuments([...uploadedDocuments]);
      setUploadLoading(false);
    }
  };

  const [assignDocumentList, setAssignDocumentList] = React.useState([]);
  const [unAssignDocumentList, setUnAssignDocumentList] = React.useState([]);
  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, "") !== id
    );
    setUploadedDocuments(filtered);
  };
  const [loading1, setLoading1] = React.useState(false);
  const useUnAssignedFiles = async () => {
    try {
      setLoading1(true);
      let payload = {
        vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
        vc_document_ids: selectedIds,
      };
      let resp = await VendorCheckpointAssignDocument(payload);
      if (resp) {
        setLoading1(false);
        toast.success("Updated successfully");
        props.handleModal();
        props.getData();
      } else {
        setLoading1(false);
      }
    } catch (error) {
      setLoading1(false);
    }
  };

  const [selectedIds, setSelectedIds] = React.useState<any>([]);
  const handleCheckBox = (id: string) => {
    let ids = selectedIds.filter((item: any) => id === item);
    if (ids.length === 0) {
      selectedIds.push(id);
      setSelectedIds([...selectedIds]);
    } else {
      let filtered = selectedIds.filter((item: any) => id !== item);
      setSelectedIds(filtered);
    }
  };
  const handleRemoveUploadedFiles1 = (id: string, index: number) => {
    let filtered = assignDocumentList.filter(
      (item: any, key: any) => index !== key
    );
    setAssignDocumentList(filtered);
  };
  const handleRemoveUploadedFiles2 = (id: string, index: number) => {
    let filtered = unAssignDocumentList.filter(
      (item: any, key: any) => index !== key
    );
    setUnAssignDocumentList(filtered);
  };

  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  return (
    <div className="attach-files-wrapper">
      <Modal
        isOpen={getValue(props, `isOpen`, "")}
        toggle={getValue(props, `isOpen`, "")}
        centered
        size="lg"
      >
        <div className="attach-files-wrapper__title-section d-flex justify-content-between">
          <h3 className="attach-files-wrapper__title">Attach File</h3>
          <div className="d-flex justify-content-end">
            <button
              className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
              onClick={() => props.handleModal()}
            >
              Cancel
            </button>
            {submitLoading ? (
              <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                Please wait...
              </button>
            ) : (
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                onClick={handleSubmit}
                // disabled={getValue(uploadedDocuments, `length`, 0) === 0}
              >
                {"Submit"}
              </button>
            )}
          </div>
        </div>
        <ModalBody>
          <div>
            <div>
              <div>
                <h6 className="comments-popup__vendor-name">Task ID</h6>
                <p className="comments-popup__vendor-text">
                  {getValue(props, `vendorInfo.task_id`, "")}
                </p>
              </div>
              <div className="comments-popup__vendor-details">
                <h6 className="comments-popup__vendor-name">Legislation</h6>
                <p className="comments-popup__vendor-text">
                  {getValue(
                    props,
                    `vendorInfo.checkpoint.legislation.legislation_name`,
                    ""
                  )}
                </p>
              </div>
            </div>
            {uploadLoading ? (
              <label className="input-file-label w-100 text-center cursor-pointer mb-4">
                <input
                  // type={'file'}
                  // onChange={handleUploadDocumnets}
                  multiple
                  className="d-none"
                />
                <div className="custom-inputfile">
                  <img
                    src="/images/input-file.png"
                    className="img-fluid mb-2"
                    height={40}
                    width={40}
                  />
                  <p className="custom-inputfile__text">Please wait...</p>
                </div>
              </label>
            ) : (
              <label className="input-file-label w-100 text-center cursor-pointer mb-4">
                {/* <input
							type={'file'}
							onChange={handleUploadDocumnets}
							multiple
							className="d-none"
						/> */}
                {/* <FileUploader
									handleChange={handleUploadDocumnets}
									name="file"
									types={fileTypes}
									multiple
									// className="d-none"
									classes="bulk-upload_drag-n-drop-wrapper position-absolute"
								/>
								<div className="custom-inputfile">
									<img
										src="/images/input-file.png"
										className="img-fluid mb-2"
										height={40}
										width={40}
									/>
									<p className="custom-inputfile__text">
										Drag & Drop Files here
									</p>
									<p className="custom-inputfile__text">OR</p>
									<a href="#0">Browse Files</a>
								</div> */}
                <DragAndDropFileComponent
                  uploadFile={handleUploadDocumnets}
                  name="file"
                  types={fileTypes}
                  multiple
                  // className="d-none"
                  classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                />
              </label>
            )}
            {getValue(uploadedDocuments, `length`, 0) > 0 && (
              <div className="mb-3">
                <h3 className="attach-files-wrapper__select">
                  Select from uploaded files
                </h3>
                {getValue(uploadedDocuments, `length`, 0) > 0 ? (
                  uploadedDocuments.map((item: object, key: number) => {
                    return (
                      <div
                        key={key}
                        className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                      >
                        <p>
                          {getValue(item, `name`, "")}
                          {getValue(item, `extension`, "")}
                        </p>
                        <div>
                          <img
                            src="/images/close-black.svg"
                            className="img-fluid cursor-pointer"
                            onClick={() =>
                              handleRemoveUploadedFiles(
                                getValue(item, `id`, "")
                              )
                            }
                          />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
              </div>
            )}

            {getValue(unAssignDocumentList, `length`, 0) > 0 && (
              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <h3 className="attach-files-wrapper__select">
                    Select from the unassigned files
                  </h3>
                  {/* <button
									onClick={useUnAssignedFiles}
									disabled={
										loading1 || getValue(selectedIds, `length`, 0) === 0
									}
									className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center"
								>
									{loading1
										? 'Please Wait...'
										: 'Submit from Assigned/Un Assigned'}
								</button> */}
                </div>
                {getValue(unAssignDocumentList, `length`, 0) > 0 ? (
                  unAssignDocumentList.map((item: object, key: number) => {
                    return (
                      <>
                        <div
                          key={key}
                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                        >
                          <p>{getValue(item, `document.name`, "")}</p>

                          <input
                            type="checkbox"
                            onChange={() =>
                              handleCheckBox(
                                `${getValue(item, `id`, "")}:${getValue(
                                  item,
                                  `document.id`,
                                  ""
                                )}`
                              )
                            }
                            checked={selectedIds.includes(
                              `${getValue(item, `id`, "")}:${getValue(
                                item,
                                `document.id`,
                                ""
                              )}`
                            )}
                          />
                          {/* <div>
											<img
												src="/images/close-black.svg"
												className="img-fluid cursor-pointer"
												onClick={() =>
													handleRemoveUploadedFiles2(
														getValue(item, `id`, ""),
														key
													)
												}
											/>
										</div> */}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
              </div>
            )}

            {getValue(assignDocumentList, `length`, 0) > 0 && (
              <div>
                <h3 className="attach-files-wrapper__select">
                  Select from the assigned files
                </h3>
                {getValue(assignDocumentList, `length`, 0) > 0 ? (
                  assignDocumentList.map((item: object, key: number) => {
                    return (
                      <>
                        <div
                          key={key}
                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                        >
                          <p>{getValue(item, `document.name`, "")}</p>
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleCheckBox(
                                `${getValue(item, `id`, "")}:${getValue(
                                  item,
                                  `document.id`,
                                  ""
                                )}`
                              )
                            }
                            checked={selectedIds.includes(
                              `${getValue(item, `id`, "")}:${getValue(
                                item,
                                `document.id`,
                                ""
                              )}`
                            )}
                          />
                          {/* <div>
											<img
												src="/images/close-black.svg"
												className="img-fluid cursor-pointer"
												onClick={() =>
													handleRemoveUploadedFiles1(
														getValue(item, `id`, ""),
														key
													)
												}
											/>
										</div> */}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UploadModal;
